import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchX } from "lucide-react";
import { Button } from "../../components/ui/button/index.js";

export function CampaignNotFoundState({
  listHref,
}: {
  listHref: string;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <section
      className="grid w-full max-w-md justify-items-center gap-3 justify-self-center rounded-xl border border-line/70 bg-surface px-4 py-8 text-center"
      data-testid="campaign-not-found"
    >
      <span
        className="inline-grid size-10 place-items-center rounded-full border border-line/70 bg-surface-muted text-muted"
        aria-hidden="true"
      >
        <SearchX size={18} />
      </span>
      <div className="grid gap-1">
        <h2 className="m-0 text-[1rem] font-semibold tracking-[-0.01em]">
          {t("campaigns.notFound.title")}
        </h2>
        <p className="m-0 text-[0.8125rem] leading-snug text-muted">
          {t("campaigns.notFound.description")}
        </p>
      </div>
      <Button asChild size="sm">
        <Link to={listHref} data-testid="campaign-not-found-back">
          {t("campaigns.actions.backToCampaigns")}
        </Link>
      </Button>
    </section>
  );
}
